var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ma-4", attrs: { app: "" } },
    [
      _c(
        "v-container",
        { staticClass: "full-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { md: "6" } }, [
                _c(
                  "div",
                  { staticClass: "shadow sm:rounded-md sm:overflow-hidden" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-5 space-y-6 bg-white border-b border-gray-200 sm:p-6"
                      },
                      [
                        _c(
                          "h3",
                          { staticClass: "text-lg font-medium text-gray-900" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("customer.page.dashboard.products")
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "pb-5 space-y-6 bg-white" },
                      [_c("ProductsTable")],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "px-4 py-3 text-right bg-gray-50 sm:px-6"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "font-semibold text-teal-500 transition duration-150 ease-in-out hover:text-teal-600",
                            attrs: { to: "subscriptions" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "customer.page.dashboard.seemoreproducts"
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c("v-col", { attrs: { md: "6" } }, [
                _c(
                  "div",
                  { staticClass: "shadow sm:rounded-md sm:overflow-hidden" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-5 space-y-6 bg-white border-b border-gray-200 sm:p-6"
                      },
                      [
                        _c(
                          "h3",
                          { staticClass: "text-lg font-medium text-gray-900" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("customer.page.dashboard.uploads")
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "pb-5 space-y-6 bg-white" },
                      [_c("SessionsTable")],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "px-4 py-3 text-right bg-gray-50 sm:px-6"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "font-semibold text-teal-500 transition duration-150 ease-in-out hover:text-teal-600",
                            attrs: { to: "subscriptions" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "customer.page.dashboard.seemoresessions"
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "flex center-center" },
            [
              _c(
                "v-col",
                { staticClass: "justify-center", attrs: { md: "6" } },
                [
                  _c("div", {
                    staticClass: "shadow sm:rounded-md sm:overflow-hidden"
                  })
                ]
              ),
              _c(
                "v-col",
                { staticClass: "justify-center", attrs: { md: "6" } },
                [
                  _c("div", {
                    staticClass: "shadow sm:rounded-md sm:overflow-hidden"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }